import React from 'react';

function responsiveSrcSet(src) {
  if (!src) return undefined;

  try {
    const url = new URL(src);
    const baseWidth = Number(url.searchParams.get('w'));
    if (url.hostname !== 'images.unsplash.com' || !Number.isFinite(baseWidth) || baseWidth <= 0) {
      return undefined;
    }

    const widths = [...new Set([320, 480, 640, 800, 1000, 1200, baseWidth]
      .filter((width) => width <= baseWidth)
      .sort((a, b) => a - b))];

    return widths
      .map((width) => {
        const variant = new URL(url);
        variant.searchParams.set('w', String(width));
        return `${variant.toString()} ${width}w`;
      })
      .join(', ');
  } catch {
    return undefined;
  }
}

function OptimizedImage({
  src,
  alt,
  className,
  sizes = '100vw',
  loading = 'lazy',
  fetchPriority,
  width = 1200,
  height = 800,
  onError,
  onLoad,
  ...rest
}) {
  if (!src) return null;

  return (
    <img
      src={src}
      srcSet={responsiveSrcSet(src)}
      sizes={sizes}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      fetchPriority={fetchPriority}
      width={width}
      height={height}
      onError={onError}
      onLoad={onLoad}
      {...rest}
    />
  );
}

export default React.memo(OptimizedImage);